import * as UI from "../framework/ui.js";
import * as toast from "../framework/components/toast.js";

let componentsRendererInstance;

UI.onDataActionClick("popup:open", ({ _el, target }) => {
  if (!target || target.id != "preview-extranet-popup") {
    return;
  }

  const containerId = "description-components-preview";
  const componentsPreview = target.querySelector(`#${containerId}`);

  import("@a-world-for-us/elearning_content_editor")
    .then(({ ComponentsRenderer }) => {
      componentsRendererInstance = ComponentsRenderer;
      ComponentsRenderer.init({
        elementId: containerId,
        componentsPayload: JSON.parse(componentsPreview.dataset.editableComponents),
        shouldTrackProgress: false,
        config: {
          language: window._locale,
        },
      });
    })
    .catch((error) => console.error(error));
});

UI.onDataActionClick("popup:close", ({ el, _target }) => {
  // We cannot rely on parameter 'target' as it is null, when the popup is closed using
  // the up right cross.

  const popup = el.closest(".popup");
  if (popup && popup.id == "preview-extranet-popup") {
    componentsRendererInstance.destroy();
  }
});

$(document).on("click", ".js-custom-name-button-confirmation", setTrainingSessionCustomName);
function setTrainingSessionCustomName() {
  const urlPath = document.querySelector(".custom-name-form").getAttribute("data-commit-url");
  const customName = document.querySelector(".custom-training-session-name-input").value;
  const data = { training_session: { custom_name: customName } };

  ajax({
    url: urlPath,
    method: "POST",
    data: data,
    dataType: "json",
    error: function () {
      toast.show("#save-custom-name-error-toast");
    },
    success: function (result) {
      const toastId = result.success ? "#save-custom-name-success-toast" : "#save-custom-name-error-toast";
      toast.show(toastId);
    },
  });
}
